export default __webpack_public_path__ + "static/media/Major Rune Stone of the First Circle.fb6d4f34.jpg";